module.exports = __webpack_public_path__ + "static/media/banner1.dba43521.jpg";